import { IContestEvaluationCriterion } from '../../../services/Contests/interfaces'

/**
 * ABRA-74 — default criteria used to pre-fill a contest that has none yet.
 * Weights are percentages and must sum to 100. Kept in sync with the
 * retroactive migration (migrate_legacy_art_evaluation_grades).
 */
export const DEFAULT_EVALUATION_CRITERIA: { name: string; weight: number }[] = [
  { name: 'Originalidade', weight: 30 },
  { name: 'Técnica', weight: 25 },
  { name: 'Conceito', weight: 25 },
  { name: 'Apresentação', weight: 20 }
]

/**
 * Weighted average of one evaluator's grades across the contest's criteria.
 * Weights are percentages; the divisor is their actual sum so the result is
 * correct even if they don't add up to exactly 100. Returns null unless every
 * criterion has a grade — mirroring the backend's "fully evaluated" rule.
 */
export function calculateWeightedAverage(
  gradesByCriterion: Record<number, number | null | undefined>,
  criteria: Pick<IContestEvaluationCriterion, 'id' | 'weight'>[]
): number | null {
  if (criteria.length === 0) return null

  let weightedSum = 0
  let weightSum = 0

  for (const criterion of criteria) {
    const grade = gradesByCriterion[criterion.id]
    if (grade === null || grade === undefined) return null
    weightedSum += grade * criterion.weight
    weightSum += criterion.weight
  }

  return weightSum > 0 ? Number((weightedSum / weightSum).toFixed(2)) : null
}
